// This is just for the demo. Fetch data with an API jwt token
// Should be removed completely in production

import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { RootState } from "../app/store";
import { PageHeader } from "../components/PageHeader";
import { TableSkeleton } from "../components/TableSkeleton";
import { fetchCountries } from "../features/country/countrySlice";
import { useTranslate } from "../i18n";
import { getErrorMessage } from "../utils/getErrorMessage";

export const CountriesList = () => {
    const dispatch = useAppDispatch();
    const t = useTranslate();
    const countries = useAppSelector((state: RootState) => state.country.countries);
    const status = useAppSelector((state: RootState) => state.country.status);
    const error = useAppSelector((state: RootState) => state.country.error);

    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchCountries());
        }
    }, [status, dispatch]);

    const [isErrorDismissed, setIsErrorDismissed] = useState(false);

    useEffect(() => {
        setIsErrorDismissed(false);
    }, [status])

    const handleOk = () => {
        setIsErrorDismissed(true);
        dispatch(fetchCountries());
    }

    const handleCancel = () => {
        setIsErrorDismissed(true);
    }

    const failed = status === "error" || status === "auth-error";
    const errorMessage = getErrorMessage(error, t);

    // This screen is routed outside the app shell, so it carries `.page` itself.
    return (
        <div className="page">
            <PageHeader
                eyebrow={t("countries.eyebrow")}
                title={t("countries.title")}
                count={status === "success" ? countries.length : undefined}
                subtitle={t("countries.subtitle")}
            />

            {status === "success"
                ? <div className="country-list">
                    {countries.map(country => (
                        <div className="country-list__item" key={country.name}>{country.name}</div>
                    ))}
                </div>
                : <TableSkeleton />}

            <Modal
                title={errorMessage.title}
                visible={failed && !isErrorDismissed}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={t("common.retry")}
            >
                <p>{errorMessage.details}</p>
            </Modal>
        </div>
    );
}
